import { render, staticRenderFns } from "./ajax-multi-select.vue?vue&type=template&id=64344962"
import script from "./ajax-multi-select.vue?vue&type=script&lang=js"
export * from "./ajax-multi-select.vue?vue&type=script&lang=js"
import style0 from "./ajax-multi-select.vue?vue&type=style&index=0&id=64344962&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports